import React from 'react';

import Select, {SingleValue} from 'react-select';

import { getCustomStyles } from '@/utils/customStyleSelect';

type Option = {
    value: string,
    label: string,
}

type SelectShipProps = {
    name: string,
    value: string,
    defaultValue?: Option,
    options: Option[],
    handleChange?: (newValue: SingleValue<Option>) => void,
    placeholder?: string,
    hasError?: boolean,
    isDisabled?: boolean,
    isClearable?: boolean,
}

const SelectShip: React.FC<SelectShipProps> = ({ name, value, defaultValue, options, handleChange, placeholder, hasError, isDisabled, isClearable = false }) => (
    <Select
        name={name}
        value={options.find((option) => option.value === value)}
        onChange={handleChange}
        options={options}
        defaultValue={defaultValue}
        placeholder={placeholder}
        styles={getCustomStyles(Boolean(hasError))}
        isDisabled={isDisabled}
        isClearable={isClearable}
    />
);

export default SelectShip;
